import { useEffect, useState } from 'react';
import { ensureCustomerSelection, syncSelectedCustomerFromUrl } from '../lib/selectedCustomer';
import { getDisplayCustomerName } from '../lib/customerDisplay';

export function useSelectedCustomerName({ redirectIfMissing = false } = {}) {
  const [customerName, setCustomerName] = useState(() => {
    syncSelectedCustomerFromUrl();
    return getDisplayCustomerName();
  });

  useEffect(() => {
    ensureCustomerSelection({ redirectIfMissing });
    setCustomerName(getDisplayCustomerName());
  }, [redirectIfMissing]);

  return customerName;
}